import { createLoadingReducer } from './utils';

export default createLoadingReducer('ILOQ_SETTINGS');
